import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { strVal } from '../../../../modules/Utils'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import { Link } from 'react-router-dom'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import QuotesApi from '../../../../api/Sales/Quotes'
import { isEmpty } from 'lodash'
import DateCell from '../../../../elements/Table/Cells/DateCell'

VendorLinesHistory.propTypes = {}
const columns = [
  {
    Header: 'Vendor Quote No',
    accessor: 'spquote.quoteNo',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/vendor/quotes/${original.spquote._key}/update`,
        }}
        target={'_blank'}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ value, original }) => value || strVal(original, 'product.name'),
  },
  {
    Header: 'Date',
    accessor: 'spquote.date.created',
    Cell: DateCell,
  },
  {
    Header: 'Vendor',
    accessor: 'spquote.vendor.fn',
  },
  {
    Header: 'Quantity',
    accessor: 'unit',
    Cell: MoneyCell,
  },
  {
    Header: 'Rate',
    accessor: 'rate',
    Cell: MoneyCell,
  },
]
const api = new QuotesApi()

function VendorLinesHistory (props) {
  const { line } = props
  const { fetch, fetching, list } = useFetchList(
    () => api.lines.vendorHistory(line._key),
    [line._rev],
    isEmpty(line._key),
  )

  return (
    <CustomTable
      columns={columns}
      data={list}
      fetching={fetching}
      fetch={fetch}
    />
  )
}

export default VendorLinesHistory
